<template>
    <div>
        <footer>
            <div class="container hidden-sm">
                <div class="row text-center d-flex justify-content-between">
                    <div class="col-md-3">
                        <ul>
                            <li><h3>Hanneke Knibbe</h3></li>
                            <li><a href="mailto:j.j.knibbe@gmail.com">j.j.knibbe@gmail.com</a></li>
                        </ul>
                    </div>
                    <div class="col-md-3">
                        <ul>
                            <li><h3>Nico Knibbe</h3></li>
                            <li><a href="mailto:nico@knibbe.info">nico@knibbe.info</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
        <div class="row text-center footer-bg-dark pt16 pb16">
            <span class="color-white sub">
                © {{ year }} LOCOmotion |
                <a class="color-white" href="https://www.locomotion.nl/privacyverklaring">Privacyverklaring</a> |
                <a href="/pdf/verzend-en-retourbeleid.pdf" class="color-white" target="_blank">Verzend- en retourbeleid</a> |
                <a href="/pdf/leveringsvoorwaarden.pdf" class="color-white" target="_blank">Leveringsvoorwaarden</a><br>
                Knibbe Gezondheidkundig Advies | KVK 08187410 0000 | BTW NL001726470B79 | Bloemendaallaan 48 3771 HW Barneveld |
                <a href="tel:+31624591398" class="color-white"> +31 6 245 913 98</a> |
                <a href="mailto:nico@knibbe.info" class="color-white">nico@knibbe.info</a>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DefaultFooter',
    data() {
        return {
            year: new Date().getFullYear()
        }
    }
}
</script>
